import React, { useState } from "react";
import NumberInput from "../../../../components/NumberInput";
import { isBuyerPriceEditLocked } from "../../Orders/utils/buyerPriceEdit";

export function FavoritePriceFormatter({row, handleBlur, user, supplier}){
    const initialFavoritePrice = row.favoritePrice ? row.favoritePrice : 0
    const [favoritePrice, setFavoritePrice] = useState(initialFavoritePrice)

    return (
        <>
            {(user && user.tenant === process.env.REACT_APP_PEPEGANGA_TENANT) || isBuyerPriceEditLocked(supplier) ? (
                <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                    ${favoritePrice}
                </span>
            ) : (
                <NumberInput
                    value={favoritePrice}
                    onChange={(e) => setFavoritePrice(e.target.value)}
                    onBlur={() => handleBlur(favoritePrice, row)}
                    className={`form-control form-control-solid h-auto py-2 px-6`}
                    min="0"
                />
            )}
        </>
    )
}
